module.exports = __webpack_public_path__ + "img/logoseebcurvelo.af9fc07d.svg";